// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileNotAllowedRouteModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing_unit_4);
  background: var(--color_neutral_0);
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing_6);
  text-align: center;
  max-width: 320px;
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing_4);
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-body .MobileNotAllowedRouteModal-title {
  font-size: 1.25rem;
  font-weight: 600;
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-body .MobileNotAllowedRouteModal-description {
  font-size: 0.875rem;
  white-space: pre-wrap;
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-divider {
  position: relative;
  width: 100%;
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-divider > div {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1.25rem;
  color: var(--color_neutral_500);
  background: var(--color_neutral_0);
  padding: 0 var(--spacing_3);
  position: relative;
  margin: 0 auto;
  z-index: 1;
}
.MobileNotAllowedRouteModal .MobileNotAllowedRouteModal-content .MobileNotAllowedRouteModal-divider::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--color_neutral_500);
}`, "",{"version":3,"sources":["webpack://./src/components/MobileNotAllowedRouteModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAAN;AAEM;EACE,kBAAA;EACA,gBAAA;AAAR;AAGM;EACE,mBAAA;EACA,qBAAA;AADR;AAKI;EACE,kBAAA;EACA,WAAA;AAHN;AAKM;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAHR;AAMM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,0CAAA;AAJR","sourcesContent":[".MobileNotAllowedRouteModal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  z-index: 999;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing_unit_4);\n  background: var(--color_neutral_0);\n\n  .MobileNotAllowedRouteModal-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing_6);\n    text-align: center;\n    max-width: 320px;\n\n    .MobileNotAllowedRouteModal-body {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing_4);\n  \n      .MobileNotAllowedRouteModal-title {\n        font-size: 1.25rem;\n        font-weight: 600;\n      }\n  \n      .MobileNotAllowedRouteModal-description {\n        font-size: 0.875rem;\n        white-space: pre-wrap;\n      }\n    }\n  \n    .MobileNotAllowedRouteModal-divider {\n      position: relative;\n      width: 100%;\n  \n      & > div {\n        width: fit-content;\n        font-size: 1.25rem;\n        color: var(--color_neutral_500);\n        background: var(--color_neutral_0);\n        padding: 0 var(--spacing_3);\n        position: relative;\n        margin: 0 auto;\n        z-index: 1;\n      }\n  \n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background-color: var(--color_neutral_500);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
